import { useEffect, useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Loading } from '../Loading/Loading';
import './ConfirmWithLoader.css'

export default function ConfirmWithLoaderV2({
  showModal,
  setShowModal,
  onConfirm,
  onClose,
  isLoading = false,
  isSuccess = false,
  isError = false,
  title,
  children,
  textButtonCancel = "Cancel",
  textButton = "Confirmar",
  disabledConfirmButton = false,
  hideContentInLoading = true,
  hideActionAfterConfirm = true,
  size = "md",
  scrollToHeader = false,
  justView = false
}) {

  const modalHeaderRef = useRef();

  const handleCloseModal = () => {
    setShowModal(false);
    // onClose && onClose();
  };

  const handleExitedModal = () => {
    // setShowModal(false);
    onClose && onClose();
  };

  const handleConfirm = () => {
    onConfirm && onConfirm();
  };

  useEffect(() => {
    if (scrollToHeader) {
      const modalElement = modalHeaderRef.current?.dialog;
      const headerElement = modalElement?.querySelector('.modal-header');
      if (headerElement) {
        headerElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [scrollToHeader]);

  return (
    <>
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        onExited={handleExitedModal}
        backdrop="static"
        keyboard={false}
        size={size}
        ref={modalHeaderRef}
        centered
        className='mw-750p'>
        <Modal.Header className='px-4 py-3'>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className='mx-0 my-0 py-4 px-10'>

          {hideContentInLoading ? (
            isLoading ? (
              <div className="text-center">
                <div>
                  <Loading></Loading>
                </div>
              </div>
            ) : (
              children
            )
          ) : (
            <>
              {isLoading && (
                <>
                  <div className="confirmWithLoader-overlay">
                    <div className='position-absolute top-50 start-50 translate-middle'>
                      <Loading></Loading>
                    </div>
                  </div>
                </>
              )}
              {children}
            </>
          )}

        </Modal.Body>
        <Modal.Footer className="px-9 py-3">
          {justView ? (
            <Button variant="secundary" size="sm" onClick={handleCloseModal}>
              Cerrar
            </Button>
          ) : (hideActionAfterConfirm ? (
            <>
              {isSuccess || isError ? (
                <Button variant="secundary" size="sm" onClick={handleCloseModal}>
                  Cerrar
                </Button>
              ) : (!isLoading ? (
                <>
                  <Button variant="secundary" size="sm" onClick={handleCloseModal}>
                    {textButtonCancel}
                  </Button>
                  <Button disabled={disabledConfirmButton} variant="primary" size="sm" onClick={handleConfirm}>
                    {textButton}
                  </Button>
                </>
              ) : (
                <>
                  <Button variant="secundary" size="sm" disabled={true} onClick={handleCloseModal}>
                    {textButtonCancel}
                  </Button>
                  <Button disabled={true} variant="primary" size="sm" onClick={handleConfirm}>
                    {textButton}
                  </Button>
                </>

              ))}
            </>
          ) : (
            <>
              {isLoading ? (
                <>
                  <Button variant="secundary" disabled={true} size="sm">
                    {textButtonCancel}
                  </Button>
                  <Button disabled={true} variant="primary" size="sm">
                    {textButton}
                  </Button>
                </>

              ) : (
                <>
                  <Button variant="secundary" size="sm" onClick={handleCloseModal}>
                    {textButtonCancel}
                  </Button>
                  <Button disabled={disabledConfirmButton} variant="primary" size="sm" onClick={handleConfirm}>
                    {textButton}
                  </Button>
                </>
              )}
            </>
          )


          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};